import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import {
  Activity,
  AlignCenter,
  AlignLeft,
  AlignRight,
  AlertTriangle,
  Archive,
  ArrowLeft,
  BarChart2,
  Bold,
  BookOpen,
  Boxes,
  Brain,
  Check,
  CheckCircle,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Code,
  Columns2,
  Construction,
  Eye,
  FileCheck,
  FileEdit,
  FileQuestion,
  FileText,
  Flag,
  Flame,
  FlaskConical,
  Focus,
  FolderTree,
  GitBranch,
  GripVertical,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heart,
  HeartHandshake,
  HelpCircle,
  History,
  Home,
  Image,
  Info,
  Italic,
  LayoutList,
  Layers,
  Link,
  Link2,
  List,
  ListOrdered,
  LogIn,
  LogOut,
  LucideAngularModule,
  Maximize2,
  Minimize2,
  Minus,
  MoveRight,
  Newspaper,
  Pencil,
  Plus,
  PanelLeft,
  PanelRight,
  Quote,
  RotateCcw,
  Ruler,
  ScrollText,
  Send,
  Settings,
  Shield,
  ShieldCheck,
  Sparkles,
  SquareCode,
  Strikethrough,
  Sun,
  Table,
  Target,
  ThumbsUp,
  Trash2,
  TrendingDown,
  TrendingUp,
  User,
  UserCheck,
  UserCog,
  UserPlus,
  Users,
  Waypoints,
  X,
  Zap,
} from 'lucide-angular';

import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { Configuration } from '@/api';
import { environment } from '@/environments/environment';
import { AuthInterceptor } from '@/auth.interceptor';
import * as echarts from 'echarts';
import { provideEchartsCore } from 'ngx-echarts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withInMemoryScrolling({ anchorScrolling: 'enabled' })),
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({
        includeRequestsWithAuthHeaders: true,
        filter: (req: { method: string }) => req.method === 'GET',
      }),
    ),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideEchartsCore({ echarts }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: Configuration,
      useValue: new Configuration({
        basePath: environment.apiUrl,
        withCredentials: true,
        credentials: { bearer: () => undefined },
      }),
    },
    importProvidersFrom(
      LucideAngularModule.pick({
        Activity,
        AlignCenter,
        AlignLeft,
        AlignRight,
        AlertTriangle,
        Archive,
        Boxes,
        ArrowLeft,
        BarChart2,
        Bold,
        BookOpen,
        Brain,
        Check,
        ChevronDown,
        ChevronLeft,
        Clock,
        ClipboardCheck,
        ClipboardList,
        CheckCircle,
        CheckSquare,
        ChevronRight,
        Code,
        Columns2,
        Construction,
        Eye,
        Flame,
        FileCheck,
        FileEdit,
        FileQuestion,
        FileText,
        FlaskConical,
        Flag,
        Focus,
        FolderTree,
        GitBranch,
        GripVertical,
        Heading1,
        Heading2,
        Heading3,
        Heading4,
        Heart,
        HeartHandshake,
        HelpCircle,
        History,
        Home,
        Image,
        Info,
        Italic,
        LayoutList,
        Layers,
        Link,
        Link2,
        List,
        ListOrdered,
        LogIn,
        LogOut,
        Maximize2,
        Minimize2,
        Minus,
        MoveRight,
        Newspaper,
        Pencil,
        PanelLeft,
        PanelRight,
        Plus,
        Quote,
        RotateCcw,
        Ruler,
        ScrollText,
        Send,
        Settings,
        Shield,
        ShieldCheck,
        Sparkles,
        SquareCode,
        Strikethrough,
        Sun,
        Table,
        Target,
        ThumbsUp,
        TrendingDown,
        TrendingUp,
        Trash2,
        User,
        UserCheck,
        UserCog,
        Users,
        UserPlus,
        Waypoints,
        X,
        Zap,
      }),
    ),
  ],
};
